import React, { useState, useEffect } from 'react'
import { api } from '../../app/Api/ApiSlice'
import { toast } from 'react-toastify'
import InfiniteScroll from 'react-infinite-scroll-component'
import { Link } from 'react-router-dom'
import UserPostCard from '../../components/UserPostCard'
import Loader from '../../components/Loader'


// loggedin user posts
const UserPosts = () => {
    const [userPosts, setUserPosts] = useState([])
    const [page, setPage] = useState(1)
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        const getUserPosts = async () => {
            try {
                setIsLoading(true)
                const response = await api.get("/posts", { params: { page } })
                // console.log(response)
                if (response) {
                    setIsLoading(false)
                    setUserPosts(response?.data)
                }
            } catch (error) {
                setIsLoading(false)
                toast.error(error.response?.data.message)
                console.log(error)
            }
        }

        getUserPosts()
    }, [])
    return (
        <div className='userposts-container users-page-container'>
            <div className="userposts-header">
                <h3>Posts</h3>
                <div className="feeds-header-link">
                    <Link to="/create" className="nav-link">
                        <p>create</p>
                    </Link>
                </div>
            </div>
            {
                isLoading && <Loader />
            }
            {!isLoading && userPosts.length === 0 && (
                <p className="not-found-msg">No posts found.</p>
            )}
            <div className="userposts">
                <InfiniteScroll
                    data={userPosts}
                    dataLength={() => userPosts.length}
                >{
                        userPosts.length > 0 && userPosts.map((post) => (
                            <UserPostCard userPost={post} key={post._id} />
                        ))
                    }

                </InfiniteScroll>
            </div>
        </div>
    )
}

export default UserPosts